export default class Character {
    id!: string;
    sessionId!: string;
    entityId!: string;
    type!: string;
    name!: string;
    nickname!: string;
    role!: string;
    stats: { name: string, value: number }[] = [];
    inventory: any[] = [];
    imageUrl?: string;
    
    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);
            this.stats = Array.isArray(data.stats) ? data.stats : [];
            this.inventory = Array.isArray(data.inventory) ? data.inventory : [];
        } else {
        }
    }
}
